import { ChangeDetectionStrategy, Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { BaseResizableComponent } from '@src/app/modules/base';
import { PreviousRouteService } from '@src/core/services';

@Component({
  selector: 'lp-product-request-list-header',
  templateUrl: './product-request-list-header.component.html',
  styleUrls: ['./product-request-list-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductRequestListHeaderComponent extends BaseResizableComponent {
  private readonly previousRouteService = inject(PreviousRouteService);

  @Input() title?: string;
  @Output() add = new EventEmitter();

  onClickBackButton() {
    this.previousRouteService.back('/loyalty');
  }
}
